import { z } from "zod";

import { zActionSchema } from "./action";
import { zEntityNameSchema } from "./entity-name";

const zSchema = z.object({
  id: z.string().uuid(),
  action: zActionSchema,
  entity: z.object({
    name: zEntityNameSchema,
    id: z.string().uuid(),
  }),
  isRead: z.boolean(),
  createdAt: z.date(),
});

type Schema = z.infer<typeof zSchema>;

export { zSchema };
export type { Schema };
